<template>
  <div class="w1200 auto confirm-order-panel">
    <div class="confirm-order-title">{{titleName}}</div>
    <div class="confirm-order-body">
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    titleName: {
      default: ''
    }
  }
}
</script>

<style lang="scss">
@import "../../static/css/confirm-order-panel.scss";
</style>



// WEBPACK FOOTER //
// src/components/confirm-order-panel.vue